import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl text-background-50">
                奶泡动漫
              </span>
            </Link>
            <p className="text-background-400 text-sm leading-relaxed">
              高品质动漫在线观看平台，海量日漫国漫番剧资源，高清流畅播放，让追番成为一种享受。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-background-400 hover:text-background-100 text-sm transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-background-400 hover:text-background-100 text-sm transition-colors">
                  分类浏览
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-400 hover:text-background-100 text-sm transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">番剧分类</h4>
            <ul className="space-y-2.5">
              <li><span className="text-background-400 text-sm">日漫番剧</span></li>
              <li><span className="text-background-400 text-sm">国漫精选</span></li>
              <li><span className="text-background-400 text-sm">剧场版</span></li>
              <li><span className="text-background-400 text-sm">OVA特典</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-background-400 text-sm">
                <i className="ri-mail-line text-base"></i>
                <span>contact@naipadongman.com</span>
              </li>
              <li className="flex items-center gap-2 text-background-400 text-sm">
                <i className="ri-weibo-line text-base"></i>
                <span>@奶泡动漫官方</span>
              </li>
              <li className="flex items-center gap-2 text-background-400 text-sm">
                <i className="ri-wechat-line text-base"></i>
                <span>naipadongman</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} 奶泡动漫 NaipaDongman. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-200 text-xs transition-colors" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 text-xs transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 text-xs transition-colors" rel="nofollow">
              DMCA
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}